import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Fragment } from 'react';
import { Document, Page } from 'react-pdf';
import PopUp from '../PopUp/PopUp';
import './GlobalPdfViewer.css';
const GlobalPdfViewer = ({
  file, // can be url, file and more
  renderMode, // can be none,canvas,svg,
  scale,
  setScale,
  rotate,
  handleLoading,
  error,
  loadingComponent
}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [popType, setPopType] = useState('loading');
  const [popUpText, setPopUpText] = useState('Loading PDF..');
  const [loading, setLoading] = useState(true);
  const [failedToLoad, setFailedToLoad] = useState(false);

  const myRef = useRef(null);
  useEffect(() => {
    if (handleLoading && typeof handleLoading == 'function') {
      handleLoading(loading);
    }
  }, [loading]);
  const doubleClickLister = useCallback(
    e => {
      if (
        myRef.current &&
        myRef.current.contains(e.target) &&
        typeof setScale == 'function'
      ) {
        if (scale === 1) {
          setScale(2);
        } else {
          setScale(1);
        }
      }
    },
    [scale]
  );

  useEffect(() => {
    document.addEventListener('dblclick', doubleClickLister, true);
    return () => {
      document.removeEventListener('dblclick', doubleClickLister, true);
    };
  }, [scale]);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
    setPageNumber(1);
  };
  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <React.Fragment>
      <Document
        file={file}
        renderMode={renderMode}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={() => {
          setLoading(false);
          setFailedToLoad(true);
        }}
        error={
          error || (
            <span className="text-red-100 font-medium mt-20 test-left">
              Failed to load the PDF file...!
            </span>
          )
        }
      >
        <div ref={myRef}>
          <Page
            scale={scale}
            className="object-cover max-w-full mx-auto"
            pageNumber={pageNumber}
            rotate={rotate}
          />
        </div>
      </Document>
      {!loading && !failedToLoad ? (
        <div className="page-controls">
          <button
            type="button"
            disabled={pageNumber <= 1}
            onClick={previousPage}
          ></button>
          <span>
            Page {pageNumber || (numPages ? 1 : '--')} of {numPages || '--'}
          </span>
          <button
            type="button"
            disabled={pageNumber >= numPages}
            onClick={nextPage}
          >
            ›
          </button>
        </div>
      ) : null}
      {!handleLoading && (
        <Fragment>
          {loadingComponent && loading ? (
            loadingComponent
          ) : (
            <PopUp
              setShow={setLoading}
              show={loading}
              type={popType}
              text={popUpText}
              dontClose
            />
          )}
        </Fragment>
      )}
    </React.Fragment>
  );
};
export default GlobalPdfViewer;
